
<h1 style="text-align: center;
    position: relative;
    top: 2em;
    font-size: 35px;
    font-weight: 600;
    text-decoration: underline;">
    App Programming CMS
</h1>
<div class="login-page">
  <!-- Left Section: Logo -->
  <div class="logo-section">
    <img src="../../../assets/1.svg" alt="Smart Code Logo" class="logo" />
  </div>

  <!-- Right Section: Login Form -->
  <div class="login-container">
    <h2>Login</h2>
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <label for="username">Username</label>
      <input type="text" id="username" formControlName="username" placeholder="Username"
        [ngClass]="{'error-border': loginForm.get('username')?.invalid && loginForm.get('username')?.touched}"
        required />
      <div class="error-message" *ngIf="loginForm.get('username')?.invalid && loginForm.get('username')?.touched">
        Username is required.
      </div>

      <label for="password">Password</label>
      <div class="input-group">
        <input [type]="isPasswordVisible ? 'text' : 'password'" id="password" formControlName="password"
          placeholder="Password"
          [ngClass]="{'error-border': loginForm.get('password')?.invalid && loginForm.get('password')?.touched}"
          required />
        <i style="color:black !important" class="fa" [ngClass]="isPasswordVisible ? 'fa-eye-slash' : 'fa-eye'"
          (click)="isPasswordVisible = !isPasswordVisible"></i>
      </div>
      <div class="error-message" *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
        Password is required.
      </div>

      <div class="remember-me">
        <input type="checkbox" id="remember-me" formControlName="rememberMe" />
        <label for="remember-me">Remember Me</label>
      </div>

      <button type="submit" [disabled]="loginForm.invalid">Login</button>
    </form>
  </div>
</div>
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
  <p style="color: white">Please Wait. </p>
</ngx-spinner>